import { IExtendedEvent, IRequestConfig } from '../types';

const requestUrl = {
    development: 'https://master.api-campaign.sandbox.d2c.r-one.io',
    production: 'https://api-campaign.web-api.dom.ru',
};

type TRequestProps = Required<Pick<IRequestConfig, 'agreementNumber' | 'environment'>> & {
    events: IExtendedEvent[],
}

export const postEvents = async({ agreementNumber, environment, events }: TRequestProps): Promise<void> => {
    const baseUrl = environment === 'production' ? requestUrl.production : requestUrl.development;

    await fetch(`${baseUrl}/api/v1/analytics/events`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'agreementNumber': `${agreementNumber}`,
        },
        body: JSON.stringify({ events }),
    });
};
